var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav'),_c('router-view'),_c('footer',{staticClass:"float-start w-100 footer-total-01"},[_c('div',{staticClass:"main-footer01 d-inline-block w-100 py-5"},[_c('div',{staticClass:"container"},[_c('FooterNav'),_c('hr',{staticClass:"mt-5"}),_c('FooterText')],1)])]),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }